import React, { lazy } from 'react';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from './Carousel';
export function Testimonials() {
  const testimonials = [{
    name: 'Austin',
    photo: 'https://cdn.magicpatterns.com/uploads/h4fqmpAPteychUPB8yEWtA/ausitn-fp.png',
    quote: 'Chris simplified everything and helped me grow faster than I thought possible.'
  }, {
    name: 'Andrew',
    photo: 'https://cdn.magicpatterns.com/uploads/i1aTgYPNT4gn253jmsCH35/andrew-fp.png',
    quote: 'I went from having no clear plan to confidently navigating real estate decisions.'
  }, {
    name: 'Zee',
    photo: 'https://cdn.magicpatterns.com/uploads/95jAymqapcGS6y6Vu6d4Uh/zee-fp.png',
    quote: 'Chris simplified everything, I finally understood how this game works.'
  }, {
    name: 'Justin',
    photo: 'https://cdn.magicpatterns.com/uploads/bCdVFZwst5N4LLdcaoXxCx/justin-fp.png',
    quote: 'Chris does not just teach, he connects you to real opportunities.'
  }, {
    name: 'Abe',
    photo: 'https://cdn.magicpatterns.com/uploads/bMB3CCdLD3bz8GUYrgEZXT/abe-fp.png',
    quote: 'Chris has real success, and he is committed to helping you reach yours.'
  }];
  return <section className="py-20 md:py-32 bg-brand-navy" data-id="element-192">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-193">
        <h2 className="font-display text-white text-3xl md:text-5xl font-bold uppercase text-center mb-16 tracking-wide" data-id="element-194">
          Real Investors. Real Results.
        </h2>

        <div className="relative px-12 md:px-16" data-id="element-195">
          <Carousel opts={{
          align: 'start',
          loop: false,
          slidesToScroll: 3,
          containScroll: 'trimSnaps'
        }} className="w-full" data-id="element-196">
            <CarouselContent className="-ml-4" data-id="element-197">
              {testimonials.map((t, i) => <CarouselItem key={i} className="pl-4 md:basis-1/2 lg:basis-1/3" data-id="element-198">
                  <div className="bg-white rounded-2xl p-8 h-full flex flex-col shadow-xl" data-id="element-199">
                    {/* Stars */}
                    <div className="flex gap-1 mb-6" data-id="element-200">
                      {[...Array(5)].map((_, i) => <svg key={i} className="w-5 h-5 text-brand-gold fill-current" viewBox="0 0 20 20" data-id="element-201">
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-202" />
                        </svg>)}
                    </div>

                    {/* Quote */}
                    <p className="font-body text-gray-800 italic text-lg leading-relaxed flex-grow mb-4" data-id="element-203">
                      "{t.quote}"
                    </p>

                    <a href="#" className="text-sm text-gray-500 hover:text-brand-gold transition-colors mb-8 inline-block" data-id="element-204">
                      Read more
                    </a>

                    {/* Author */}
                    <div className="flex items-center gap-4 mt-auto" data-id="element-205">
                      <img src={t.photo} alt={`${t.name} headshot`} className="w-12 h-12 rounded-full object-cover" loading="lazy" decoding="async" data-id="element-206" />
                      <div data-id="element-207">
                        <div className="font-bold text-gray-900" data-id="element-208">{t.name}</div>
                        <div className="text-sm text-gray-500" data-id="element-209">
                          Bigger Profits Student
                        </div>
                      </div>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <CarouselPrevious className="bg-transparent border-brand-gold text-brand-gold hover:bg-brand-gold hover:text-black -left-4 md:-left-8 h-12 w-12" data-id="element-210" />
            <CarouselNext className="bg-transparent border-brand-gold text-brand-gold hover:bg-brand-gold hover:text-black -right-4 md:-right-8 h-12 w-12" data-id="element-211" />
          </Carousel>

          {/* Dot pagination — 2 screens (3 cards + 2 cards) */}
          <div className="flex justify-center gap-2 mt-12" data-id="element-212">
            <div className="w-2.5 h-2.5 rounded-full bg-brand-gold" data-id="element-213"></div>
            <div className="w-2.5 h-2.5 rounded-full bg-brand-gold/30" data-id="element-214"></div>
          </div>
        </div>
      </div>
    </section>;
}